import ShCard from '@/components/Helpers/ShCard';
import ShButton from '@/components/Helpers/ShButton';
import PopupHints from '@/components/Common/PopupHints';
import ShPopconfirm from '@/components/Helpers/ShPopconfirm';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import HintAndExplanation from '@/components/Common/HintAndExplanation';
import DomainListItem from './DomainListItem';

// @vue/component
export default {
  name: 'DomainsList',

  components: {
    ShPopconfirm,
    ShCard,
    ShButton,
    PopupHints,
    ShModalWindow,
    HintAndExplanation,
    DomainListItem,
  },

  data() {
    return {
      domain: null,
      hintModalVisible: false,
    };
  },

  computed: {
    warningTooltipValue() {
      return this.domainsList.length > this.possibleNumberOfDomainsAccordingToAccessPermissionsDefinitions;
    },
    possibleNumberOfDomainsAccordingToAccessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'].global_options.number_of_domains;
    },
    domainsList() {
      return this.$store.getters['domains/list'];
    },
    isEmpty() {
      return this.domainsList.length === 0;
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'domains/getList',
        'domains/create',
        'domains/delete',
      ]);
    },
  },

  created() {
    this.$store.dispatch('domains/getList');
  },


  methods: {
    async handleAddNewDomain() {
      if (!this.domain) return;
      await this.$store.dispatch('domains/create', this.domain);
      this.$notify.success({
        title: 'Dodanie domeny',
        message: `Dodano domenę: ${this.domain}`,
        customClass: 'callmeweb-notification',
      });
      this.domain = null;
      await this.$store.dispatch('domains/getList');
    },

    async handleDeleteDomain(domain) {
      try {
        await this.$store.dispatch('domains/delete', domain.id);
        this.$notify.success({
          title: 'Usunięcie domeny',
          message: `Usunięto domenę: ${domain.domain}`,
          customClass: 'callmeweb-notification',
        });
        await this.$store.dispatch('domains/getList');
      } catch (err) {
        console.log();
      }
    },
  },
};
